import Section from "../section";

export default class Staff extends Section {

  constructor(props) {
    super(props);


    this.subtotalEl = this.form.find('.catcalc-summary-staff-cost input');
    this.bartendersQtyEl = this.form.find('.catcalc-summary-staff-bartenders-count input');
    this.serversQtyEl = this.form.find('.catcalc-summary-staff-servers-count input');

  }


  supervisor() {
    if(this.calculator.event.wedding &&
      this.calculator.event.wedding.toLowerCase() == 'yes'
    ){
      return 200;
    }

    return 100;
  }

  servers() {
    return this.serversQty() * this.hours() * 25;
  }

  serversQty() {
    if(this.calculator.event.style == 'buffet') {
      if(this.calculator.event.dishes == 'real dishware') {
        return Math.ceil(this.calculator.event.guests / 30);
      }
      if (this.calculator.event.dishes == 'disposable') {
        return Math.ceil(this.calculator.event.guests / 50);
      }
    }

    if (this.calculator.event.style) {
      return Math.ceil(this.calculator.event.guests / 15);
    }

    return 0;
  }

  bartenders() {
    switch (this.calculator.beverages.bar.value) {
      case 'bartender(s) only, supplying our own beer and wine':
      case 'beer & wine only tier one':
      case 'beer & wine only tier two':
        return this.bartendersQty() * this.hours() * 25;
      case 'well bar with beer & wine':
      case 'top shelf bar with beer & wine':
      case 'bartender(s) only, supplying our own beer, wine and liquor for mixed drinks':
        return this.bartendersQty() * this.hours() * 35;
    }
    return 0;
  }

  bartendersQty() {
    switch(this.calculator.beverages.bar.value) {
      case 'bartender(s) only, supplying our own beer and wine':
      case 'beer & wine only tier one':
      case 'beer & wine only tier two':
          return Math.ceil(this.calculator.event.guests / 75);
      case 'well bar with beer & wine':
      case 'top shelf bar with beer & wine':
      case 'supplying our own beer, wine and liquor for mixed drinks':
          return Math.ceil(this.calculator.event.guests / 50);
    }

    return 0;
  }

  hours() {
    // eslint-disable-next-line no-debugger
    debugger
    if (this.calculator.event.wedding &&
      this.calculator.event.wedding.toLowerCase() == 'yes'
    ) {
      return 11;
    }

    return 8;
  }

  total() {
    let total = this.supervisor() + this.servers() + this.bartenders();
    this.subtotalEl.val(this.format(total));
    this.bartendersQtyEl.val(this.bartendersQty());
    this.serversQtyEl.val(this.serversQty());
    return total;
  }

}




// WEBPACK FOOTER //
// ./scripts/catcalc/sections/staff.js